module.exports = __webpack_public_path__ + "img/news1.f7af35f8.png";